import { render, staticRenderFns } from "./newUserToProject.vue?vue&type=template&id=732f2f00&"
import script from "./newUserToProject.vue?vue&type=script&lang=js&"
export * from "./newUserToProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports